import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlyAdminLegacyBaseUrl, FlyGarminLegacyBaseUrl } from '@garmin-avcloud/avcloud-fly-web-common/_shared';
import { of, tap } from 'rxjs';
const FLY_WEB_COMMON_CONFIG = new InjectionToken('FLY_WEB_COMMON_CONFIG');
const CONFIG_PATH = '/api/config';
let SiteConfigService = /*#__PURE__*/(() => {
  class SiteConfigService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      if (this.config.site === 'FALA') {
        this.url = FlyAdminLegacyBaseUrl[this.config.environment];
      } else if (this.config.site === 'FGA') {
        this.url = FlyGarminLegacyBaseUrl[this.config.environment];
      } else {
        throw new Error(`Invalid site: ${this.config.site}`);
      }
    }
    getSiteConfig() {
      return this.cache != null ? of(this.cache) : this.loadSiteConfig();
    }
    loadSiteConfig() {
      return this.http.get(this.getSiteConfigUrl()).pipe(tap(config => this.cache = config));
    }
    getSiteConfigUrl() {
      return `${this.url}${CONFIG_PATH}`;
    }
    static {
      this.ɵfac = function SiteConfigService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SiteConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SiteConfigService,
        factory: SiteConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SiteConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FLY_WEB_COMMON_CONFIG, SiteConfigService };
